module.exports = function() {
  return new Worker(__webpack_public_path__ + "2eed81930211773e5064.worker.js");
};